import React from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';

import { Typography } from '@material-ui/core';

import { convertToEstablishmentName, convertToReal } from 'helpers/converters';
import { formatPhone } from 'helpers/formatters';

const header = [
  { title: 'Nome' },
  { title: 'E-mail' },
  { title: 'Telefone' },
  { title: 'Situação da fatura' },
  { title: 'Data de vencimento' },
  { title: 'Valor da fatura' },
  { title: 'Veículos' },
  { title: 'Vagas' },
  { title: 'Observação' }
];

const ClientsExport = React.forwardRef((props, ref) => {
  const { establishmentId } = useSelector(state => state.businessInfo);
  const { establishments } = useSelector(state => state.login);
  const { startDate, endDate } = useSelector(state => state.dateFilter);
  const { selects } = useSelector(state => state.filters);

  const establishmentName = convertToEstablishmentName(establishmentId, establishments) || 'Todos os estabelecimentos';

  const invoiceSituations = selects
    ?.find(filter => filter?.id == 'clientInvoiceSituation')
    ?.options;

  const getSituationId = (clientTypeId, clientInvoiceSituationId, dueDateTime) => {
    if(+clientTypeId == 1) {
      return '';
    }

    return moment(dueDateTime, 'YYYY-MM-DD HH:mm:ss').isBefore(moment(), 'day') && +clientInvoiceSituationId == 1 ? 2 : 1;
  }

  const formattedData = props?.data?.content?.length > 0 && props?.data?.content?.map(item => {
    return {
      establishmentName: item?.establishmentName || '-',
      name: item?.name || '-',
      email: item?.email || '-',
      phone: item?.phones?.length > 0 ? formatPhone(item?.phones[0]) : '-',
      situation: !!item?.clientInvoiceSituationId ? invoiceSituations?.find(situation => +situation?.value == getSituationId(item?.clientTypeId, item?.clientInvoiceSituationId, item?.dueDateTime))?.label : '-',
      dueDateTime: !!item?.dueDateTime ? moment(item?.dueDateTime, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY') : '-',
      amount: convertToReal(item?.invoiceAmount || ''),
      vehicles: item?.vehicles?.join(', ')?.toString() || '-',
      vacancies: item?.vacancies || '-',
      observation: item?.comments || ''
    }
  });

  return(
    <div ref={ref} style={{ width: '100%', padding: 10 }}>
      <div>
        <Typography color='primary'>
          Clientes
        </Typography>
      </div>
      <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography color='primary'>
          Estabelecimento: {establishmentName}
        </Typography>
        <Typography color='primary'>
          {moment(startDate, 'YYYY-MM-DD').format('DD/MM/YYYY')} - {moment(endDate, 'YYYY-MM-DD').format('DD/MM/YYYY')}
        </Typography>
      </div>
      <div style={{ width: '100%', marginTop: 20 }}>
        <table style={{ width: '100%', tableLayout: 'fixed', border: '1px solid #000000', borderCollapse: 'collapse' }}>
          <tr style={{ width: '100%', borderBottom: 'thin solid' }}>
            {!establishmentId && (
              <th style={{ borderRight: 'thin solid', textAlign: 'left', padding: 5 }}>
                Estabelecimento
              </th>
            )}
            {header.map(item => (
              <th style={{ borderRight: 'thin solid', textAlign: 'left', padding: 5 }}>
                {item.title}
              </th>
            ))}
          </tr>
          {formattedData?.length > 0 && formattedData?.map(item => (
            <tr style={{ width: '100%', borderBottom: 'thin solid' }}>
              {!establishmentId && (
                <td style={{ borderRight: 'thin solid', textAlign: 'left', padding: 5, wordWrap: 'break-word' }}>
                  {item?.establishmentName}
                </td>
              )}
              <td style={{ borderRight: 'thin solid', color: '#505050', padding: 5, wordWrap: 'break-word' }}>{item?.name}</td>
              <td style={{ borderRight: 'thin solid', color: '#505050', padding: 5, wordWrap: 'break-word', wordBreak: 'break-all' }}>{item?.email}</td>
              <td style={{ borderRight: 'thin solid', color: '#505050', padding: 5, wordWrap: 'break-word' }}>{item?.phone}</td>
              <td style={{ borderRight: 'thin solid', color: '#505050', padding: 5, wordWrap: 'break-word' }}>{item?.situation}</td>
              <td style={{ borderRight: 'thin solid', color: '#505050', padding: 5, wordWrap: 'break-word' }}>{item?.dueDateTime}</td>
              <td style={{ borderRight: 'thin solid', color: '#505050', padding: 5, wordWrap: 'break-word' }}>{item?.amount}</td>
              <td style={{ borderRight: 'thin solid', color: '#505050', padding: 5, wordWrap: 'break-word' }}>{item?.vehicles}</td>
              <td style={{ borderRight: 'thin solid', color: '#505050', padding: 5, wordWrap: 'break-word' }}>{item?.vacancies}</td>
              <td style={{ borderRight: 'thin solid', color: '#505050', padding: 5, wordWrap: 'break-word' }}>{item?.observation}</td>
            </tr>
          ))}
        </table>
      </div>
      <div style={{ backgroundColor: '#E2E2E2', padding: 10, border: '1px solid #000000', borderTop: 'none' }}>
        {(+props?.data?.total == 1) ? (
          <p style={{ color: '#505050', margin: 0 }}>
            Este relatório tem {props?.data?.total} item.
          </p>
        ) : (
          <p style={{ color: '#505050', margin: 0 }}>
            Este relatório tem {props?.data?.total} itens.
          </p>
        )}
      </div>
    </div>
  );
});

export default ClientsExport;